import * as React from "react";

import { AutocompleteType } from "@/shared/components/TagAndMetadataAutocomplete";
import { TagInput, TagsGroup, Tags } from "@/shared/components/tags";
import { UpdateActionRequest } from "@/shared/domain/actions/ActionRecord";

interface UpdateActionTagsProps {
  initialTags: string[];
  onChange: (updates: UpdateActionRequest) => void;
  setErrorText: (arg: string) => void;
  canEdit?: boolean;
}

export function UpdateActionTags({
  initialTags,
  onChange,
  setErrorText,
  canEdit,
}: UpdateActionTagsProps) {
  const [tags, setTags] = React.useState<string[]>(initialTags);

  const tagAdded = (tag: string) => {
    const newTags = tags.concat([tag]);
    setTags(newTags);
    updateTags({
      metadata_changeset: {
        put_tags: [tag],
      },
    });
  };

  const tagRemoved = (tag: string) => {
    const newTags = tags.filter((e) => e !== tag);
    setTags(newTags);
    updateTags({
      metadata_changeset: {
        remove_tags: [tag],
      },
    });
  };

  const updateTags = (updates: UpdateActionRequest) => {
    setErrorText("");
    onChange(updates);
  };

  return (
    <TagsGroup>
      <Tags
        tags={tags}
        onDeleteTag={canEdit ? tagRemoved : undefined}
        truncateText={false}
      />
      <TagInput
        autocompleteType={AutocompleteType.ActionTags}
        onAddTag={tagAdded}
        tags={tags}
      />
    </TagsGroup>
  );
}
